var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect } from "react";
import { IconError, IconConfirmation, IconInfo, IconWarning } from "@wrstudios/icons";
import Portal from "../portal/Portal";
import { Container } from "./styled/toast";
import { colors } from "@wrstudios/theme";
function Toast(_a) {
    var variant = _a.variant, message = _a.message, props = __rest(_a, ["variant", "message"]);
    var _b = useState(true), showToast = _b[0], setShowToast = _b[1];
    useEffect(function () {
        setInterval(function () {
            setShowToast(false);
        }, 5000);
        return function () {
            clearInterval();
        };
    }, []);
    var styles = { width: "25px", height: "25px", marginRight: "15px" };
    return showToast ? (React.createElement(Portal, null,
        React.createElement(Container, __assign({ variant: variant }, props),
            variant === "error" && (React.createElement(IconError, { style: __assign({ fill: colors.red[600] }, styles) })),
            variant === "success" && (React.createElement(IconConfirmation, { style: __assign({ fill: colors.green[600] }, styles) })),
            variant === "info" && (React.createElement(IconInfo, { style: __assign({ fill: colors.blue[600] }, styles) })),
            variant === "warning" && (React.createElement(IconWarning, { style: __assign({ fill: colors.yellow[600] }, styles) })),
            message))) : null;
}
export default Toast;
